import type { Dictionary } from '@ts/dictionary';
import type { VariantAttribute } from '@ts/variant';

import { formatPrice } from '@utils/currency/formatPrice';

export const renderVariantPrice = (
  attrs: VariantAttribute[] | undefined,
  dictionary: Dictionary,
) => {
  if (!attrs?.length) return '-';

  const sortedPrices = attrs.sort((a, b) => a.price.price - b.price.price);
  const min = sortedPrices.at(0);
  const max = sortedPrices.at(-1);

  if (!min || !max) return '-';

  return (
    <div className="flex flex-col-reverse">
      <span className="font-bold">
        {min.price.price < max.price.price && (
          <>
            {dictionary?.fromShortened}
            &nbsp;
          </>
        )}
        <span className="font-bold">{formatPrice(min.price.price)}</span>
      </span>
      {min.price.priceType === 'campaign' && (
        <span className="text-grey-300 ml-2 text-xs line-through">
          {formatPrice(min.price.originalPrice ?? 0)}
        </span>
      )}
    </div>
  );
};
